import { render, staticRenderFns } from "./Bilgiler.vue?vue&type=template&id=66fafa23&scoped=true"
import script from "./Bilgiler.vue?vue&type=script&lang=js"
export * from "./Bilgiler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fafa23",
  null
  
)

export default component.exports